import { useLeague } from "./useLeague";

interface SetupStatus {
  hasLeague: boolean;
  needsSetup: boolean;
  isLoading: boolean;
}

export function useSetupStatus(): SetupStatus {
  const { leagues, isLoading } = useLeague();

  const hasLeague = leagues.length > 0;
  const needsSetup = !hasLeague && !isLoading;

  return {
    hasLeague,
    needsSetup,
    isLoading,
  };
}
